// @flow
import type {GraphQLTaggedNode} from 'react-relay'
import {graphql} from 'react-relay'
import {pathOr} from 'ramda'

import type {Strategy} from 'components/proposals/types'

import Editor from './Editor'
import Summary from './Summary'
import createPartComponent from '../createPartComponent'
import type {Change, State} from './types'
import changePayload from './changePayload'
import fetchFieldsFromChange from './fetchFieldsFromChange'

/* eslint class-methods-use-this: 0 */

const query = {
  subscriptionChange: graphql`
    fragment MoveItemsSubscription_change on DescribeChangeable {
      ... on MoveItemsChange {
        roleHasBeenRemoved
        
        policiesToMoveUp {
          databaseId
        }
        
        policiesToMoveDown {
          databaseId
        }
        
        rolesToMoveUp {
          databaseId
        }
        
        rolesToMoveDown {
          databaseId
        }
      }
    }
  `,
  change: graphql`
    fragment MoveItems_change on DescribeChangeable {
      id
      databaseId
      command
      type
      
      alerts {
        path
        message
        severity
      }
      
      ... on MoveItemsChange {
        role {
          databaseId
          
          circlePolicies {
            edges {
              node {
                databaseId
                displayName: title
                resourcePath
              }
            }
          }
          
          circleRoles {
            edges {
              node {
                databaseId
                displayName: localizedName
                resourcePath
              }
            }
          }
        }
        
        childSupportedRole {
          databaseId
          localizedName
          
          circlePolicies {
            edges {
              node {
                databaseId
                displayName: title
                resourcePath
              }
            }
          }
          
          circleRoles {
            edges {
              node {
                databaseId
                displayName: localizedName
                resourcePath
              }
            }
          }
        }
      }
      
      ...MoveItemsSubscription_change @relay(mask: false)
    }
  `,
}

class MoveItemsStrategy implements Strategy {
  static displayName: string = 'MoveItems'
  static fieldsFromChange: ((Change) => any) = fetchFieldsFromChange
  static query: {[string]: GraphQLTaggedNode, ...} = query

  change: Change
  changeKey: string
  state: Object

  constructor(change: Change) {
    this.change = change
    this.changeKey = `Part-MoveItems-${(change && change.databaseId) || 'new'}`
    this.state = fetchFieldsFromChange(change)
  }

  get className(): string {
    return 'move-items-part'
  }

  get childRoleName(): string {
    return pathOr('', ['childSupportedRole', 'localizedName'], this.change)
  }

  get partDescription(): string {
    return this.childRoleName
  }

  get partTitle(): string {
    return I18n.t('proposals.circle_restructure.restructure_subcircle2')
  }

  get error(): ?string {
    if (this.change.roleHasBeenRemoved)
      return I18n.t('proposals.react.part_not_loaded')

    return this.change.alerts.map((alert) => alert.message)[0]
  }

  changePayload(state: State): Change {
    return changePayload(this.change, state)
  }
}

export {
  MoveItemsStrategy,
}

export default (createPartComponent(MoveItemsStrategy, Editor, Summary): any)
